import { Primitive } from '#src/types/common'

/**
 * @desciption Filter array of objects, deals with one level deep.
 * @param array Array of objects
 * @param key key of the object
 * @returns Array without duplicate objects based on the key
 */
export const filterDuplicateObjects = <T extends object>(
  array: T[],
  key: keyof T,
) => {
  const itemsToFilter = array.map((object) => object[key])

  return array.filter((object, index) => {
    const itemToCheck = object[key]

    if (!itemToCheck) return false

    return !itemsToFilter.includes(itemToCheck, index + 1)
  })
}

/**
 * @returns Array of the value
 * @description Normalise singular items to plural, an array is always returned
 */
export const ensureArray = <T>(payload: T | T[] | undefined | null): T[] => {
  if (!payload) return []

  return Array.isArray(payload) ? payload : [payload]
}

/**
 * @param array1 Array of primitive values
 * @param array2 Array of primitive values
 * @returns true if both arrays have the same values, regardless of order
 */
export const hasSameValues = (array1: Primitive[], array2: Primitive[]) => {
  const set1 = new Set(array1)
  const set2 = new Set(array2)
  if (set1.size !== set2.size) {
    return false
  }
  return new Set([...Array.from(set1), ...Array.from(set2)]).size === set1.size
}

export const validateStringArray = (maybeArray: unknown) => {
  if (!Array.isArray(maybeArray)) return false
  if (maybeArray.length === 0) return false
  const allElementsAreString = maybeArray.every(
    (element) => typeof element === 'string',
  )
  if (!allElementsAreString) return false
  return maybeArray as string[]
}
